import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';
import { EconomyService, ValutaItem } from '../../../services/economy.service';

@Component({
  selector: 'tt-travel-expence',
  templateUrl: './travel-expence.component.html',
  styleUrls: ['./travel-expence.component.css']
})
export class TravelExpenceComponent implements OnInit {
    public travelBillNo: string;

    travelExpenceNo;

    public trexTypeButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'travexptypes' }];

    public edit?: Edit;

    public selectListCurrencies: ValutaItem[] = [];

    public selectListExpenceTypes: ExpenceTypeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService, private economy: EconomyService) {
        this.travelBillNo = this.stateService.getStateParams()['travelbill_no'];
        this.travelExpenceNo = this.stateService.getStateParams()['travelexpence_keyno'];
    }

    private async loadEdit() {
        if (!!this.travelBillNo && !!this.travelExpenceNo) {
            this.edit = (await this.datatask.Post(1266, {
                travelbill_no: this.travelBillNo,
                travelexpence_keyno: this.travelExpenceNo
            }))[0];
        }
    }

    private async loadCurrencies() {
        this.selectListCurrencies = await this.economy.getValutas();
    }

    private async loadExpenceTypes() {
        if (!this.edit) return;

        return this.selectListExpenceTypes = await this.datatask.Post(1265, {
            travelbill_no: this.edit.travelbill_no,
            travelexpence_keyno: this.edit.travelexpence_keyno
        });
    }

    private async retrieveCurrencyExRate() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(1277, {
            valuta_id: this.edit.base_valuta_id,
            currency_id: this.edit.valuta_id,
            currencytype_keyno: '1'
        }))[0];

        this.edit.exchangerate = response?.exchangerate;
    }

    private async retrieveExchangeFactor() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(1278, {
            currency_id: this.edit.valuta_id,
            exchangerate: this.edit.exchangerate
        }))[0];

        this.edit.exchangefactor = response?.exchangerate_factor;
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1274, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1275, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public saveWork = async () => {
        if (!!this.edit) {
            const response = (await this.datatask.Post(1274, this.edit))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            }
        }
    }

    private recalcAmount() {
        if (!!this.edit) {
            this.edit.amount = this.utility.parseNumber(this.edit.amountinvaluta) * this.utility.parseNumber(this.edit.exchangerate);
        }
    }

    private recalcExchangeFactor() {
        if (!!this.edit) {
            this.edit.amount = this.utility.parseNumber(this.edit.amountinvaluta) * this.utility.parseNumber(this.edit.exchangefactor);
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'valuta_id':
                this.retrieveCurrencyExRate();
                break;
            case 'amountinvaluta':
                this.recalcAmount();
                this.recalcExchangeFactor();
                break;
            case 'exchangerate':
                this.retrieveExchangeFactor();
                break;
            case 'exchangefactor':
                this.recalcExchangeFactor();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCurrencies();
        this.loadExpenceTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    travelbill_no: string;
    trextype_id: string;
    date: string;
    amountinvaluta: string;
    exchangerate: string;
    amount: string | number;
    valuta_id: string;
    travelexpence_keyno: string;
    note: string;
    base_valuta_id: string;
    nbr_of_pictures: string;
    nbr_of_documents: string;
    exchangefactor: string;
    expence_time: string;
    expence_datetime: string;
    travelbill_admin: string;
}

interface ExpenceTypeItem {
    trextype_id: string;
    trextype_name: string;
    orderby: number;
}
